import { render, staticRenderFns } from "./type.vue?vue&type=template&id=47f2aa52&scoped=true"
import script from "./type.vue?vue&type=script&lang=js"
export * from "./type.vue?vue&type=script&lang=js"
import style0 from "./type.vue?vue&type=style&index=0&id=47f2aa52&prod&lang=scss&scoped=true"
import style1 from "./type.vue?vue&type=style&index=1&id=47f2aa52&prod&lang=scss"
import style2 from "./type.vue?vue&type=style&index=2&id=47f2aa52&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f2aa52",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/product/interview/type.vue
// module id = null
// module chunks = 